import {connect} from "react-redux";

import {postMessageToParent} from "../lookMessaging";
import {GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";
import {getLookId, getPostCartItemsList} from "../lookNavigation/lookFunctions2";
import {setIframeIntegrationRequest} from "../../../actions/iframeIntegrationFunctions";
import {saveQuote} from "../../../api/server-api";
import {setAmazonImageUrl} from "../../../actions/serverFunctions";
import {getTempIdForPostMessage, postSaveVisualizerImage} from "../../../api/look-api";
import {getQuotePriceWithTaxes, getTotalPrice, isIframe} from "../../../misc/helpers";
// import {getCurrentLayout} from "../../appLayout";
// import Config from "../../../config";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";
import {setExisingTempId} from "../../../actions/groheFunctions";
import {renderErrorPopup} from "../../../api/api-popups";
import {showQuoteSavedNotification} from "../../ui/successNotification";
import Analytics from "../../../analytics";
import {getAnalyticsEcommerceItem} from "../../../analyticsEcommerceParams";
import {updateCurrentQuote} from "../../../misc/quotesFunctions";

const WithAddToCartPostMessage = (props) => {

  const {cartItems, jobId, children, activePreset, bvPresets, setIframeIntegrationRequest, isPhoneNumberValidated,
    activeQuoteIndex, setAmazonImageUrl, setLookOverlayOpened, exisingTempId, setExisingTempId, userIsLoggedIn,
    fabricatorData} = props;
  const fabricatorSettings = fabricatorData.settings;

  const isLixil = isIframe() && fabricatorData.isLixil;

  const withoutCheckout = !isLixil && !fabricatorSettings.checkout;
  if (withoutCheckout && IS_PRODUCT_JOURNEY) { // we keep this button on the look list page
    return null
  }

  const addToCartPostMessage = async (sendFeatures= null) => {

    // const layout = getCurrentLayout();
    // await layout.updateLocalStorage();

    if (!isLixil || !fabricatorSettings.checkout) {
      if (!isPhoneNumberValidated) {
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
        return
      }
      if (withoutCheckout) {
        // we should just save the quote, everything is correct below
      }
      if (fabricatorSettings.checkout && IS_PRODUCT_JOURNEY) { // this should never execute, but let it be
        return false
      }
      setLookOverlayOpened(LOOK_OVERLAYS.loadingCart);
      return saveQuote({
        submit: true,
        showReceipt: false
      })
        .then((responseData) => {
          if (responseData.imageUrl) {
            setAmazonImageUrl(responseData.imageUrl)
          }
          setLookOverlayOpened("");
          showQuoteSavedNotification(
            fabricatorSettings.checkout ? "successNotification.titleQuoteCreated" : "successNotification.titleQuoteSaved"
          );
        })
        .catch((error) => {
          renderErrorPopup("Server "+new Error(error));
          setLookOverlayOpened("");
        })
    }

    const totalPrice = getTotalPrice(null, false, cartItems);

    Analytics.sendEcommerceEvent("add_to_cart", {
      currency: fabricatorSettings.currency,
      value: getQuotePriceWithTaxes(totalPrice),
      items: cartItems.map((cartItem, cartItemIndex) => {
        return getAnalyticsEcommerceItem(cartItem.cartFeature, cartItem.quantity, cartItemIndex)
      })
    });

    setLookOverlayOpened(LOOK_OVERLAYS.loadingCart);

    let lookImage = "";

    if (!userIsLoggedIn && !IS_PRODUCT_JOURNEY) {
      const updatedQuotes = await updateCurrentQuote();
      lookImage = await postSaveVisualizerImage({
        base64Image: updatedQuotes[activeQuoteIndex].bvImage
      });
    }

    // const useRedirect = !IS_PRODUCT_JOURNEY
    //   || (Array.isArray(sendFeatures) && sendFeatures.length > 1 && !sendFeatures.some(cartItem => featureIsBundle(cartItem.cartFeature)))

    let lookId = getLookId(activePreset, bvPresets);

    let postData = {
      "EventType": GROHE_POST_MESSAGES_ACTIONS.addToCart,
      "LookImage": lookImage ? lookImage : "No image created",
      "LookId": lookId + "",
      "LookSkus": Array.isArray(sendFeatures)
        ? getPostCartItemsList(sendFeatures, true)
        : getPostCartItemsList(cartItems, true),
      "UseRedirect": "" + !IS_PRODUCT_JOURNEY,
    }

    if(jobId) {
      postData["VisualizerId"] = jobId + ""
    }

    if (!isIframe()) {
      console.log("Not an iframe, can't post cart data:", postData);
    }

    setIframeIntegrationRequest(postData);
    if (userIsLoggedIn) {
      saveQuote({
        submit: true,
      })
        .then((responseData) => {
          if(responseData.jobId) {
            postData["VisualizerId"] = responseData.jobId + "";
          }
          postData["LookImage"] = responseData.imageUrl || lookImage || "No image created";
          if (responseData.imageUrl) {
            setAmazonImageUrl(responseData.imageUrl)
          }
          window.postMessageIsExecuting = true;
          postMessageToParent(postData);
        })
    } else {
      postData["tempID"] = await getTempIdForPostMessage("", exisingTempId);
      if (IS_PRODUCT_JOURNEY) {
        setExisingTempId(postData["tempID"]);
      }
      postMessageToParent(postData);
    }
  }

  return children(addToCartPostMessage)
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;
  const {jobId} = store.serverState;
  const {isPhoneNumberValidated, userIsLoggedIn} = store.userState;
  const {activeQuoteIndex} = store.quotesState;
  const {exisingTempId} = store.groheState;
  const fabricatorData = store.fabricatorState;

  return {
    cartItems,
    activePreset,
    bvPresets,
    jobId,
    isPhoneNumberValidated,
    userIsLoggedIn,
    // quotes,
    activeQuoteIndex,
    exisingTempId,
    fabricatorData,
  }
};

const mapDispatchToProps = {
  setIframeIntegrationRequest,
  setAmazonImageUrl,
  setLookOverlayOpened,
  setExisingTempId,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithAddToCartPostMessage)
